import { useTranslation } from "react-i18next";
import { WizardCancelButton, WizardUpdateButton } from "./buttons";
import ConfirmationModal from "../ConfirmationModal";
import { Button } from "../../basic/Button";
import { css } from "../../../../../styled-system/css";

const formButtonContainer = css({
  position: "absolute",
  bottom: 0,
  left: 0,
  justifyContent: "space-around",
  width: "100%",
  "@media (max-width: 600px)": {
    position: "relative",
    display: "flex",
  },
});

const reviewPanelButtonContainer = css({
  display: "flex",
  justifyContent: "space-around",
});

const FormWizardPagination = ({
  onPrevious,
  onPreviousText,
  onNext,
  onNextText,
  onExit,
  hidePreviousButtonVisibility,
  hideNextButtonVisibility,
  isPanelReview,
  readyToProceed,
  isProcessing = false,
  disableUpdateButton,
  hidePagination = false,
  isModal,
  hideCancelButton = false,
}) => {
  const { t } = useTranslation(["advertising", "common"]);
  if (hidePagination) {
    return null;
  }
  return isPanelReview ?
      <div className={reviewPanelButtonContainer}>
        <Button onPress={() => onNext()} isDisabled={disableUpdateButton}>
          {onNextText}
        </Button>
      </div>
    : <div className={formButtonContainer}>
        {!hidePreviousButtonVisibility && (
          <WizardCancelButton
            onClick={() => {
              onPrevious();
            }}
            text={onPreviousText}
          />
        )}

        {!hideNextButtonVisibility && (
          <WizardUpdateButton
            text={onNextText}
            onClick={() => {
              onNext();
            }}
            disabled={isProcessing}
            readyToProceed={readyToProceed}
          />
        )}
        {!isModal && !hideCancelButton && (
          <WizardCancelButton
            color={"#62407F"}
            sectionEdit={true}
            children={
              <ConfirmationModal
                title={t(($) => $.advertising["Are you sure you want to exit?"])}
                confirmationMessage={
                  <div className="fs-standard">{t(($) => $.advertising["All form progress will be removed."])}</div>
                }
                inlineModal={true}
                confirmButtonText={t(($) => $.advertising["Exit"])}
                modalButtonText={t(($) => $.common.actions.Cancel)}
                onConfirm={(e) => {
                  onExit(e);
                }}
              />
            }
          />
        )}
      </div>;
};

export default FormWizardPagination;
